import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../../providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';

@Component({
  selector: 'sm-view-business-profile',
  templateUrl: './view-business-profile.component.html',
  styleUrls: ['./view-business-profile.component.scss']
})
export class ViewBusinessProfileComponent implements OnInit, OnDestroy {
  imageUrl: string = environment.profileImageBaseUrl;
  metadata: any
  postData: any
  public loader: boolean = false;
  private _apiSubscription: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _apiService: ApiService) {

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ENTITY_DETAILS_RESULT){
      console.log(resData.result);
      resData.result.addressInfo = JSON.parse(resData.result.addressInfo)

        this.metadata = resData.result
      
        
      }
      
      this.loader = false;
    });
   }

  ngOnInit(): void {
this.loader = true
this._apiService.getEntityDetails(this.data.requestTypeInfo.hash_id)
  }


  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }


}
